// Choose to use local or hosted uri's
const hostType = 'hosted' // use hosted for MultiChoice hosting

const localURI = {
  frontEndDomain: 'http://localhost:8080/#/',
  domainURI: 'http://localhost:50/thinktank/'
}
const hostedURI = {
  frontEndDomain: 'https://thinktank.multichoice.com/#/',
  domainURI: 'https://thinktankapi.multichoice.com/'
}
const restURI = getHostType().domainURI + 'ttapi/wp/v2/'
const jwtURI = getHostType().domainURI + 'ttapi/jwt-auth/v1/token'
const authorizedHeader = {
  'Authorization': localStorage.getItem('userToken'),
  'Content-Type': 'application/json'
}

const workflowStages = ['sponsor', 'manager', 'exco2', 'hrbp']
const workflowStagesLabel = ['Project Sponsor', 'Line Manager', 'Exco2 Manager', 'HRBP']


function getHostType () {
  if (hostType === 'local') {
    return localURI
  } else {
    return hostedURI
  }
}

export default {
  frontEndDomain: getHostType().frontEndDomain,
  domainURI: getHostType().domainURI,
  restURI: restURI,
  jwtURI: jwtURI,
  authorizedHeader: authorizedHeader,
  workflowStages: workflowStages,
  workflowStagesLabel: workflowStagesLabel
}



// WEBPACK FOOTER //
// ./src/helpers/WordpressRestURI.js